import {
   GET_EMPLOYEE_LIST_SUCCESS,
   GET_EMPLOYEE_CLAIMS_LIST_SUCCESS,
   GET_EMPLOYEE_CLAIMS_LIST_FAIL,
   GET_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS,
   GET_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS,
   GET_EXPORT_EMPLOYEE_LIST_SUCCESS,
   GET_LAZY_EMPLOYEE_CLAIM_LIST_SUCCESS,
   GET_EMPLOYEE_LIST_BY_POLICY_SUCCESS,
   GET_EMPLOYEE_PANEL_VISIT_CLAIM_DATA_SUCCESS,
   RESET_HR_CLAIM_DATA,
   GET_BANK_LIST_SUCCESS
} from "../actions";

const initialState = {
   employeesLazyClaimList: [],
   employeelistData: [],
   employeeClaimsList: [],
   exportEmployees: null,
   bank_list: [],
   selectedEmployeeToView: null,
   selectedClaimToView: null,
   error: null
};

export default function(state = initialState, action) {
   switch (action.type) {
      case GET_EMPLOYEE_LIST_SUCCESS:
         return Object.assign({}, state, {
            employeelistData: action.payload.data.employees
         });
      case GET_LAZY_EMPLOYEE_CLAIM_LIST_SUCCESS:
         return Object.assign({}, state, {
            employeesLazyClaimList: action.payload.data.claims
         });
      case GET_EMPLOYEE_CLAIMS_LIST_SUCCESS:
         return Object.assign({}, state, {
            error: null,
            employeeClaimsList: action.payload.response.data.claims || [],
            selectedEmployeeToView: action.payload.selectedUserId
         });
      case GET_EMPLOYEE_CLAIMS_LIST_FAIL:
         return Object.assign({}, state, {
            error: action.payload.error,
            employeeClaimsList: [],
            selectedEmployeeToView: action.payload.selectedUserId
         });
      case GET_EMPLOYEE_OUTPATIENT_CLAIM_DATA_SUCCESS:
         return Object.assign({}, state, {
            employeeClaimData: action.payload.response.data.claim,
            selectedEmployeeToView: action.payload.selectedUserId,
            selectedClaimToView: action.payload.selectedClaimToView
         });
      case GET_EMPLOYEE_INPATIENT_CLAIM_DATA_SUCCESS:
         return Object.assign({}, state, {
            employeeClaimData: action.payload.response.data.claim,
            selectedEmployeeToView: action.payload.selectedUserId,
            selectedClaimToView: action.payload.selectedClaimToView
         });
      case GET_EMPLOYEE_PANEL_VISIT_CLAIM_DATA_SUCCESS:
         return Object.assign({}, state, {
            employeeClaimData: action.payload.response,
            selectedEmployeeToView: action.payload.selectedUserId,
            selectedClaimToView: action.payload.selectedClaimToView
         });
      case GET_EXPORT_EMPLOYEE_LIST_SUCCESS:
         return Object.assign({}, state, {
            exportEmployees: action.payload.data
         });
      case GET_EMPLOYEE_LIST_BY_POLICY_SUCCESS:
         return Object.assign({}, state, {
            employeelistData: action.payload.data.employees
         });
      case GET_BANK_LIST_SUCCESS:
         return Object.assign({}, state, {
            bank_list: action.payload.data.result
         });
      case RESET_HR_CLAIM_DATA:
         return Object.assign({}, state, {
            employeeClaimData: action.payload
         });
      default:
         return state;
   }
}
